import { PropsWithChildren } from 'react';
import {
  ConfirmationPrompt,
  ModalConfirmationFooterPromptLabelProps,
  ModalConfirmationFooterActionButtonProps,
} from './types';

// the specific type that React.memo is expecting for its props
type ComponentProp =
  | Readonly<PropsWithChildren<ModalConfirmationFooterPromptLabelProps>>
  | Readonly<PropsWithChildren<ModalConfirmationFooterActionButtonProps>>;

/** validateFooterChildComponentUpdate
 * helper function that gets called during
 * ModalConfirmationFooterActionButton and ModalConfirmationFooterPromptLabel's
 * React.memo cycle to validate whether the component should be updated.
 *
 * This is necessary due to the animation that runs before the components are unmounted.
 * Without this custom check, we may show the wrong state of the component
 * while the dismount animation runs.
 */
export function validateFooterChildComponentUpdate(
  prevProps: ComponentProp,
  newProps: ComponentProp,
): boolean {
  if (
    prevProps.promptType !== ConfirmationPrompt.NONE &&
    newProps.promptType === ConfirmationPrompt.NONE
  ) {
    return !prevProps.showExitAnimation;
  }
  return prevProps.promptType === newProps.promptType;
}
